import { useFormContext, useWatch } from "react-hook-form";
import { useIntl } from "react-intl";

import Input from "components/v2/Input/Input";
import PackingListSelect from "@RequestFormV2/sections/PackingList/components/shared/PackingListSelect";
import { getPackingListFieldPath } from "@RequestFormV2/sections/PackingList/utils/fieldPaths";
import type { TemperatureOption } from "@RequestFormV2/sections/PackingList/utils/temperatureOptions";

const CUSTOM_TEMPERATURE_VALUE = "6";

type TemperatureSelectProps = {
  index: number;
  options: TemperatureOption[];
  onChange: () => void;
};

export default function TemperatureSelect({ index, options, onChange }: TemperatureSelectProps) {
  const intl = useIntl();
  const { setValue } = useFormContext();
  const tempValue = useWatch({ name: getPackingListFieldPath(index, "temperature_control_value") });
  const isCustom = tempValue === CUSTOM_TEMPERATURE_VALUE;

  const handleChange = (value: string | null) => {
    if (!value) {
      setValue(getPackingListFieldPath(index, "temperature_controlled_custom_value"), "");
      setValue(getPackingListFieldPath(index, "temperature_control_required"), false);
    } else {
      setValue(getPackingListFieldPath(index, "temperature_control_required"), true);
      if (value !== CUSTOM_TEMPERATURE_VALUE) {
        setValue(getPackingListFieldPath(index, "temperature_controlled_custom_value"), "");
      }
    }
    onChange();
  };

  return (
    <div className="rfv2-packing-list-table__temperature">
      <PackingListSelect
        size="sm"
        isClearable
        name={getPackingListFieldPath(index, "temperature_control_value")}
        options={options}
        placeholder={intl.formatMessage({
          id: "request-form.packing-list.selectTemperature",
          defaultMessage: "Select temperature",
        })}
        onChange={handleChange}
      />
      {isCustom && (
        <Input
          name={getPackingListFieldPath(index, "temperature_controlled_custom_value")}
          onChange={onChange}
        />
      )}
    </div>
  );
}
